import { useState } from "react";
import {
  Flex,
  Box,
  Wrap,
  WrapItem,
  Tag,
  HStack,
  Text,
  Input,
  useColorModeValue,
  WrapItemProps,
  InputProps
} from "@chakra-ui/react";
import { SearchIcon, CloseIcon } from "@chakra-ui/icons";
import { TEXT_COLOR_LIGHT, TEXT_COLOR_DARK } from "./utils";

interface Props {
  placeholder: string;
  value: string[];
  onChange: (newValue: string[]) => void;
  isActive?: boolean;
  inputContainerProps?: WrapItemProps;
  inputProps?: InputProps;
}

export function ComboInput({
  value,
  onChange,
  isActive = false,
  placeholder,
  inputContainerProps = {},
  inputProps = {}
}: Props) {
  const [inputValue, setInputValue] = useState<string>("");
  const textColor = useColorModeValue(TEXT_COLOR_LIGHT, TEXT_COLOR_DARK);

  return (
    <Flex
      bg="white"
      p="0.25rem"
      alignItems="center"
      px="3"
      boxShadow="md"
      borderRadius="md"
      border={isActive ? "2px solid" : "none"}
      borderColor={isActive ? textColor : "none"}
    >
      <Box mr="2">
        <SearchIcon mt="-1" h="5" color={textColor} />
      </Box>
      <Wrap spacing="2">
        {value.map((v) => (
          <WrapItem>
            <Tag
              size="sm"
              bg="transparent"
              color={textColor}
              border="1px solid"
              borderColor={textColor}
            >
              <HStack>
                <Text>{v}</Text>
                <CloseIcon
                  h="2"
                  w="2"
                  stroke={textColor}
                  cursor="pointer"
                  onClick={() => {
                    onChange([...value].filter((r) => r !== v));
                  }}
                />
              </HStack>
            </Tag>
          </WrapItem>
        ))}
        <WrapItem minW="24" {...inputContainerProps}>
          <Input
            placeholder={placeholder}
            _placeholder={{ color: textColor }}
            border="none"
            borderRadius="none"
            w="28"
            maxW="100%"
            size="sm"
            p="0"
            pl="2px"
            h="5"
            _focus={{ boxShadow: "none", border: "none" }}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                const newValues = [...value];
                if (!newValues.includes(inputValue)) {
                  newValues.push(inputValue);
                  onChange(newValues);
                }
                setInputValue("");
              }
            }}
            {...inputProps}
          />
        </WrapItem>
      </Wrap>
    </Flex>
  );
}
